<script setup>
import { useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import HostAuthLayout from '@/Layouts/HostAuthLayout.vue'

defineOptions({ layout: HostAuthLayout })

const { t } = useI18n()
const form = useForm({ identifier: '' })
function submit() { form.post('/otp', { preserveScroll: true }) }
</script>

<template>
  <h1 class="otp-title">
    {{ t('host_portal.otp.request.title') }}
  </h1>
  <p class="otp-sub">
    {{ t('host_portal.otp.request.sub') }}
  </p>
  <form
    class="otp-form"
    @submit.prevent="submit"
  >
    <label class="otp-field">
      <span class="otp-label">{{ t('host_portal.otp.request.label') }}</span>
      <input
        v-model="form.identifier"
        type="text"
        required
        autocomplete="off"
        class="otp-input"
      >
    </label>
    <button
      type="submit"
      :disabled="form.processing"
      class="otp-submit"
    >
      {{ form.processing ? t('host_portal.otp.verify.loading') : t('host_portal.otp.request.cta') }}
    </button>
    <a
      href="/login"
      class="otp-link"
    >{{ t('host_portal.otp.request.alt') }}</a>
  </form>
</template>

<style scoped>
.otp-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.otp-sub   { color: var(--inkSoft); margin: 0 0 1rem; font-size: 0.9375rem; }
.otp-form  { display: grid; gap: 0.875rem; }
.otp-field { display: grid; gap: 0.3rem; }
.otp-label { font-size: 0.8125rem; color: var(--inkSoft); }
.otp-input {
  width: 100%; padding: 0.55rem 0.75rem; background: var(--surface);
  border: 1px solid var(--line); border-radius: var(--radius-input, 8px);
  color: var(--ink); font-size: 0.9375rem;
}
.otp-input:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.otp-submit {
  padding: 0.65rem 1rem; border: 0; border-radius: var(--radius-button, 8px);
  background: var(--accent); color: var(--accentInk); font-weight: 600; cursor: pointer;
}
.otp-submit:disabled { opacity: 0.6; cursor: progress; }
.otp-link { color: var(--accent); text-decoration: none; font-size: 0.875rem; text-align: center; }
</style>
